import { CommonFormDialog } from "@/components/common/CommonFormDialog";
import ChangePasswordForm from "@/components/forms/ChangePasswordForm";
import { Avatar, AvatarFallback } from "@/components/ui/Avatar";
import { Badge } from "@/components/ui/Badge";
import { Button } from "@/components/ui/Button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { useAuthStore } from "@/store/auth-store";
import { Lock, Mail, Phone, Shield, User } from "lucide-react";
import { useState } from "react";

const UserProfilePage = () => {
  const { user } = useAuthStore();
  const [showChangePassword, setShowChangePassword] = useState(false);

  console.log("user", user);

  return (
    <div className="space-y-6 px-4">
      <div className="grid gap-6 md:grid-cols-4">
        {/* Personal Information */}
        <Card className="col-span-4 lg:col-span-2">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-4">
              <Avatar className="border-background h-20 w-20 border-4 shadow-md">
                <AvatarFallback className="bg-sky-100 text-xl font-medium text-slate-700">
                  AD
                </AvatarFallback>
              </Avatar>
              <div>
                <CardTitle className="text-2xl">Profile</CardTitle>
                <Badge variant="success" className="mt-1 font-normal">
                  Administrator
                </Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid gap-6 sm:grid-cols-2">
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <User className="text-muted-foreground h-5 w-5" />
                  <div>
                    <p className="text-muted-foreground text-sm">Username</p>
                    <p className="font-medium">admin</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="text-muted-foreground h-5 w-5" />
                  <div>
                    <p className="text-muted-foreground text-sm">Email</p>
                    <p className="font-medium">N/A</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Shield className="text-muted-foreground h-5 w-5" />
                  <div>
                    <p className="text-muted-foreground text-sm">Role</p>
                    <p className="font-medium">admin</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="text-muted-foreground h-5 w-5" />
                  <div>
                    <p className="text-muted-foreground text-sm">Phone</p>
                    <p className="font-medium">N/A</p>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Account Security */}
        <Card className="col-span-4 lg:col-span-2">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="h-5 w-5" />
              Account Security
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between rounded-lg border p-4">
              <div className="flex items-center gap-4">
                <Lock className="text-muted-foreground h-5 w-5" />
                <div>
                  <p className="font-medium">Password</p>
                  <p className="text-muted-foreground text-sm">
                    Last changed 30 days ago
                  </p>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowChangePassword(true)}
              >
                Change
              </Button>
            </div>

            <CommonFormDialog
              title="Change Password"
              description="Enter your current password and choose a new one."
              isOpen={showChangePassword}
              onOpenChange={setShowChangePassword}
            >
              <ChangePasswordForm
                setShowChangePassword={setShowChangePassword}
              />
            </CommonFormDialog>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default UserProfilePage;
